import { Fab } from '@atgfr8/atg-ui-tailwind';
import { CheckCircleIcon } from '@atgfr8/icons';
import { type JSX, createMemo, mergeProps, Show } from 'solid-js';

export const FABInput = (inProps: {
  label: string;
  checked: boolean;
  onClick: () => void;
  iconSize?: string;
  sxProps?: JSX.CSSProperties;
  class?: string;
  labelClass?: string;
  color?: 'primary' | 'secondary';
  truncateLabel?: boolean;
}) => {
  const props = mergeProps({ iconSize: '16px' }, inProps);

  const baseClass =
    'text-[13px]! rounded-[17px]! font-normal! h-fit! py-1! px-2! shadow-none! capitalize! whitespace-nowrap! leading-[1.2]! border-0! hover:border-0!';
  const uncheckedClass = `${baseClass} bg-[#e0e0e0]! text-[rgba(0,0,0,0.87)]! hover:bg-[#d5d5d5]!`;
  const checkedClass = `${baseClass} bg-[#026EA1]! text-white! hover:bg-[#015a85]!`;

  const fabClass = createMemo(() => {
    const stateClass = props.checked ? checkedClass : uncheckedClass;
    return props.class ? `${stateClass} ${props.class}` : stateClass;
  });

  return (
    <Fab
      extended
      size="small"
      color={props.checked ? (props.color ?? 'primary') : undefined}
      onClick={props.onClick}
      class={fabClass()}
      style={props.sxProps}
      type="button"
    >
      <div class="flex items-center min-w-0">
        <span
          class={
            props.truncateLabel
              ? `truncate min-w-0 ${props.labelClass ?? ''}`
              : props.labelClass
          }
        >
          {props.label}
        </span>

        <Show when={props.checked}>
          <CheckCircleIcon
            class="text-[#4494ba]! ml-1 shrink-0"
            size={props.iconSize}
          />
        </Show>
      </div>
    </Fab>
  );
};
